import {combineReducers} from 'redux';

import Locale from './locale';
import Avatar from './avatar';
import Router from './router';

const reducers = combineReducers({
    locale: Locale,
    avatar: Avatar,
    router: Router
});

export default reducers;